import { useMutation } from '@tanstack/react-query'

import { deleteFreeeConnected } from '@src/api'
import { DefaultApiDeleteFreeeConnectedRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteFreeeConnected = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteFreeeConnectedRequest) =>
      deleteFreeeConnected(axiosInstance, params),
  })
}
